import React, { FC } from "react";
import { countZero } from "../../utils/utils";
import "../StaticPriceComp/StaticPriceComp.css";
interface DynamicPriceSchema {
  content: any;
  showPrice?: any;
  addToCart?: (e: any) => void;
}

const DynamicPrice: FC<DynamicPriceSchema> = ({
  content,
  showPrice,
  addToCart,
}) => {
  const base: number = showPrice?.base ?? 0;
  let discount = showPrice?.discount?.[0]?.value ?? 0;
  showPrice?.discount?.map((item: any) => {
    item?.cycleStart == 1 ? (discount = item?.value) : "";
  });
  const contractDuration: number = showPrice?.contractDuration;

  return (
    <div className={`linetable-staticPrice-priceWrapper`}>
      {showPrice?.base ? (
        <>
          {discount > 0 && (
            <span className="linetable-staticPrice-discountPriceSection">
              <span className="linetable-staticPrice-discountedPrice">
                {countZero(discount)}
              </span>
              {content?.priceDuration}
            </span>
          )}
          <span>
            <span
              className={`linetable-staticPrice-basePrice ${
                discount > 0
                  ? "linetable-staticPrice-priceStrikeout"
                  : "linetable-staticPrice-noDiscountPrice"
              }`}
            >
              {countZero(base)} 
            </span>
            {discount === 0 && content?.priceDuration}
          </span>
          <div className="linetable-staticPrice-contractDescription">
            {!contractDuration || contractDuration === 0 ? (
                <div>{content?.contractDescription}</div>
            ) : (
              <div></div>
            )}
          </div>
        </>
      ) : (
        ''
      )}
      <div>
        <button
          className={`linetable-staticPrice-addToCart`}
          onClick={addToCart}
        >
          {content?.addButton}
        </button>
      </div>
    </div>
  );
};

export default DynamicPrice;
